/**
 * Placeholder for future animation-driven invalidation.
 * R3F already renders the scene; a manual gl.render() here duplicated GPU work every frame.
 */
export default function AnimationControl() {
  return null
}
